import React from 'react';
import { resolveEnemyStatus } from './enemyStatusMeta';

/* Static enemy-status chip chrome — the enemy-side mirror of StatusTagPill's
   `interactive={false}` form (CombatPlayerbar/statusTags.jsx). Just the
   `bls-status-header--tab` pill (icon + text) with NO CombatTooltip wrapper, so
   it can be embedded inside the enemy hover tooltip's "[verb] [chip] | def" row
   (a tooltip must never nest another tooltip) exactly like the player pill.

   `labelOnly` renders just the status DISPLAY NAME ("Glucose") — the tooltip /
   announce form that explains the mechanic generically, with no live value (the
   def line beside it is the number's source of truth, matching the Anaphyl
   grammar). Default renders the full live valueText ("Glucose 190 · hyper") for
   the status rail. Pass a pre-`resolved` object to skip re-resolving. */
export function EnemyStatusPill({ status, resolved = null, labelOnly = false }) {
  const r = resolved || resolveEnemyStatus(status);
  if (!r) return null;
  const Icon = r.Icon;
  const zoneClass = !labelOnly && r.zone
    ? `is-${String(r.zone).replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`
    : '';
  const text = labelOnly
    ? r.label
    : (r.zone && r.type === 'enemy-gauge' ? `${r.valueText} · ${r.zone}` : r.valueText);
  return (
    <span
      className={[
        'bls-status-header',
        'bls-status-header--tab',
        `bls-status-header--${r.statusClass}`,
        'status-tag-inline',
        zoneClass,
      ].filter(Boolean).join(' ')}
      aria-label={text}
      data-enemy-status-key={status?.key || r.key}
    >
      {Icon && <Icon size={14} className="bls-status-header-icon" />}
      <span className="bls-status-tab-value">{text}</span>
    </span>
  );
}

export default EnemyStatusPill;
